import { arbitrum, base, baseSepolia, arbitrumSepolia } from "@account-kit/infra";
import { bsc, celo, mantle } from "viem/chains";

// Bot merchant address constant
export const ARB_BOT_MERCHANT_ADDRESS = "0xe4A3950d0D3E77b51EcBDa3240e58A0b64589454";
export const LISK_BOT_MERCHANT_ADDRESS = "0xc0b2D205D45Aa4fc558dF3FEBD84c1d8ce5Af14B";
export const BASE_BOT_MERCHANT_ADDRESS = "0xE9B9a497392130e1Fa369acE6820BAFac52BcA5A";
export const MORPH_BOT_MERCHANT_ADDRESS = "0xF30ce494b9d64BC462B835B47A3ff408F36013FF";
export const UNI_BOT_MERCHANT_ADDRESS = "0x875c4B253EAC6994BeA5A6Ec761ad357F05f42e3";
export const HEDERA_BOT_MERCHANT_ADDRESS = "0x316e01077886b333104C12F7859cCE478263ec60";
export const CELO_BOT_MERCHANT_ADDRESS = "0xC548b5642Dad2842644000A92d1ad93A2F548AeA";
export const SCROLL_BOT_MERCHANT_ADDRESS = "0x67C63614331f799a41fd3a368E2cF570dc36A4E6";

export const BOT_MERCHANTS: [number, string][] = [
  [421614, ARB_BOT_MERCHANT_ADDRESS],
  [84532, BASE_BOT_MERCHANT_ADDRESS],
];

export const FEATURED_MERCHANTS: [number, string][] = [
  [base.id, "0x3428773A99f592203877C312B41F5CF303D83203"],
  [arbitrum.id, "0x3428773A99f592203877C312B41F5CF303D83203"],
  [mantle.id, "0x3428773A99f592203877C312B41F5CF303D83203"],
  [celo.id, "0x3428773A99f592203877C312B41F5CF303D83203"],
  [bsc.id, "0x3428773A99f592203877C312B41F5CF303D83203"],
];

export const BOT_TOOLTIP_TEXT = "Bot-operated trade with automatic and fast order fulfillment";
export const PAY_ORDER_GAS = 46_187;
export const RELEASE_ORDER_GAS = 46_187;
export const CANCEL_ORDER_GAS = 46_187;
export const APPEAL_ORDER_GAS = 46_187;
export const ACCEPT_ORDER_GAS = 46_187;
export const CREATE_ORDER_GAS = 336_217;

export const NETWORK_FAUCET_URLS = {
  421614: "https://www.alchemy.com/faucets/arbitrum-sepolia",
  84532: "https://www.alchemy.com/faucets/base-sepolia",
  4202: "https://console.optimism.io/faucet",
  2810: "https://morphfaucet.com/",
  296: "https://portal.hedera.com/faucet",
  44787: "https://faucet.celo.org/alfajores",
  534351: "https://console.optimism.io/faucet",
};

export const IN_PROGRESS_STATES = ["pending", "accepted", "intent", "paid"] as const;

export const IS_MAINNET = process.env.NEXT_PUBLIC_IX_ENV === "mainnet";

export const ZKME_APP_ID = process.env.ZKME_APP_ID;

export const ZKME_API_KEY = process.env.ZKME_API_KEY;

export const ZKME_PROGRAM_NUMBER = process.env.ZKME_PROGRAM_NUMBER;

export const MIN_TRADE_LIMIT = 0;
export const MAX_TRADE_LIMIT = 5000;

export const MIN_QUICK_TRADE_LIMIT = 10;
export const MAX_QUICK_TRADE_LIMIT = 150000;

export const P2P_SELL_FEE_PERCENT = 0.5; // 0.5% fee for sell
export const P2P_BUY_FEE_PERCENT = 0; // 0% fee for buy

export const ADMIN_ENV_STORAGE_KEY = "admin_selected_environment";

